import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfirmAddress, IPaginateResult, SellNowItem, SellNowStatusPagination, SellNowSteps, SellNowTimeline } from '../../interfaces';
import { ActiveGroupFilter, SellNowTransactionStatus } from 'src/app/enums';

@Injectable({
    providedIn: 'root'
})
export class SellNowService {
    mySellNowProductsTab: SellNowTransactionStatus = SellNowTransactionStatus.Active;
    mySellNowProductsGroupFilter: ActiveGroupFilter | null = null;
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}

    getSteps(): Observable<SellNowSteps> {
        return this.http.get<SellNowSteps>(`${this.path}/sell-now`);
    }

    /**
     * Call when:
     * user hit the send button
     * */
    saveSteps(steps: SellNowSteps): Observable<SellNowSteps> {
        return this.http.post<SellNowSteps>(`${this.path}/sell-now`, steps);
    }

    /**
     * Call when:
     * steps form has changed + user did not hit the send button + ngOnDestroy called
     * */
    saveDraft(steps: SellNowSteps): Observable<SellNowSteps> {
        return this.http.post<SellNowSteps>(`${this.path}/sell-now/draft`, steps);
    }

    /**
     * Call when:
     * user hit the clear button on first two steps
     * */
    resetDraft(): Observable<SellNowSteps> {
        return this.http.post<SellNowSteps>(`${this.path}/sell-now/reset`, {});
    }

    getSellNowTimeline(id: string): Observable<SellNowTimeline> {
        return this.http.get<SellNowTimeline>(`${this.path}/sell-now/my-timeline/${id}`);
    }

    getMyAll(payload: SellNowStatusPagination): Observable<IPaginateResult<SellNowItem>> {
        return this.http.post<IPaginateResult<SellNowItem>>(`${this.path}/sell-now/get-my-all`, payload);
    }

    acceptPrice(id: string): Observable<SellNowTimeline> {
        return this.http.patch<SellNowTimeline>(`${this.path}/sell-now/accept-price/${id}`, {});
    }
    negotiatePrice(id: string, body: { price: number }): Observable<SellNowTimeline> {
        return this.http.patch<SellNowTimeline>(`${this.path}/sell-now/negotiate-price/${id}`, body);
    }

    refusePrice(id: string): Observable<SellNowTimeline> {
        return this.http.patch<SellNowTimeline>(`${this.path}/sell-now/refuse-price/${id}`, {});
    }

    confirmAddress(id: string, payload: ConfirmAddress): Observable<SellNowTimeline> {
        return this.http.patch<SellNowTimeline>(`${this.path}/sell-now/confirm-address/${id}`, payload);
    }

    getReport(year: string): Observable<{ reportUrl: string }> {
        return this.http.get<{ reportUrl: string }>(`${this.path}/sell-now/report?year=${year}`);
    }
}
